import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import {
  Customer,
  DefaultLabel,
  FilterDefault,
  ProductType,
} from '../core/models';
import {
  DefaultsService,
  AuthenticationService,
  EquipmentService,
  ProfileService,
  SearchService,
} from '../core/providers';
import { NavService } from '../core/providers/services/nav.service';
import { FiltersService } from 'src/app/filters/filters.service';

interface IComponentBase {
  loadPageData(): unknown;
}

// TODO: figure out a better way of doing this. Having to compose this giant constructor for each component that needs access to the
//  defaultsService is no bueno.

@Component({
  selector: 'app-base',
  template: '',
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class ComponentBase implements IComponentBase {
  searchResults?: Array<ProductType> = undefined;
  clientId: number;
  clientCode: string;
  defaultLabelsSubscriptionName = 'defaultLabelsSubscription';
  defaultLabels?: Array<DefaultLabel> = undefined;
  filterDefaultsSubscriptionName = 'filterDefaultsSubscription';
  filterDefaults?: Array<FilterDefault> = undefined;
  subscriptions: Subscription[] = [];
  isSearching: boolean = false;
  isBusy: boolean = true;
  scrollContentClass: string = 'scroll-content';
  customerCountSubscriptionName = 'customerCountSubscriptionNameBase';

  constructor(
    public defaultsService: DefaultsService,
    public authenticationService: AuthenticationService,
    public equipmentService: EquipmentService,
    public profileService: ProfileService,
    public searchService: SearchService,
    public navService: NavService,
    public translateService: TranslateService,
    public route: ActivatedRoute,
    public router: Router,
    public filtersService: FiltersService
  ) {
    this.clientId =
      this.authenticationService.userInfoView.SelectedClient.ClientID;
    this.clientCode =
      this.authenticationService.userInfoView.SelectedClient.ClientCode;
    this.loadDefaults();
    this.subscriptions.push(
      this.searchService.searchResultsLoaded.subscribe((searchResults) => {
        this.searchResults = searchResults;
      })
    );
    if (this.profileService.getSelectedCustomers().length > 0) {
      this.scrollContentClass = 'scroll-content-filters';
    }
    this.subscriptions.push(
      this.profileService.selectedCustomersChanged.subscribe(
        (r: Array<Customer>) => {
          this.scrollContentClass =
            r.length > 0 ? 'scroll-content-filters' : 'scroll-content';
        }
      )
    );
    // Reload page data when filter form values change
    this.subscriptions.push(
      this.filtersService.filtersChanged.subscribe(() => {
        console.log('component.base.filtersChanged subscription triggered');
        this.loadPageData();
      })
    );
  }
  selectedCustomerCount = () => {
    return this.profileService.getSelectedCustomers().length;
  };

  // Common interface for loading page data within pages that extend this class
  loadPageData(): any {}

  loadDefaults(): void {
    this.defaultLabels = this.defaultsService.defaultLabels;
    if (!this.defaultLabels) {
      this.subscriptions.push(
        this.defaultsService.defaultLabelsLoaded.subscribe((defaultLabels) => {
          this.defaultLabels = defaultLabels;
        })
      );
      if (!this.defaultsService.areLabelsLoading()) {
        this.defaultsService.getDefaultLabels(this.clientId);
      }
    }

    this.filterDefaults = this.defaultsService.filterDefaults;
    if (!this.filterDefaults) {
      this.subscriptions.push(
        this.defaultsService.filterDefaultsLoaded.subscribe(
          (filterDefaults) => {
            this.filterDefaults = filterDefaults;
            this.loadPageData();
          }
        )
      );
      /* if (
        !this.defaultsService.filterDefaultsLoading() &&
        this.defaultsService.filterDefaultsClient() !== this.clientId
      ) {
        this.defaultsService.getFilterDefaults(this.clientId);
        this.loadPageData();
      }*/
    } else {
      this.loadPageData();
    }
  }

  getLabelTranslation = (value: string, replacements?: Array<any>) => {
    return this.profileService.getLabelTranslation(value, replacements);
  };
}
